import { theme } from '@factorialco/deprecated-design-system'
import { ThemeAPI } from '@ingestro/importer-react'

export const loader: ThemeAPI['loader'] = {
  content: {
    color: theme.colors.grey800,
  },
  loadAnimationColor: 'rgba(255, 93, 126, 1)',
}
